export default __webpack_public_path__ + "static/media/arrow.52ef5429.svg";